import type { Filter } from 'client/js/main/components/DrillDownTable/types';
import type { SetLoaderForRowActionPayload } from 'client/js/redux/domains/DrillDown/DrillDown.types';
import type { Action } from 'redux';

export const SET_LOADER_FOR_ROW = 'SET_LOADER_FOR_ROW';

export const setLoaderForRow = (filters: Filter[]): SetLoaderForRowAction => {
  return {
    type: SET_LOADER_FOR_ROW,
    data: { filters },
  };
};

export type SetLoaderForRowAction = Action<typeof SET_LOADER_FOR_ROW> & { data: SetLoaderForRowActionPayload };
